import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITenantConfig } from '../interfaces/tenant-config.interface';
import { KeyValueModel } from '../models/key-value.model';
import { TenantConfig } from '../models/tenant-config.model';

@Injectable()
export class TenantConfigService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    getTenantConfigs(): Promise<TenantConfig[]> {
        return this.http
            .get<ITenantConfig[]>(`${this.environment.apiUrl}/tenant-config`)
            .pipe(
                map((queries) =>
                    queries.map((query) => {
                        return new TenantConfig(query);
                    })
                )
            )
            .toPromise();
    }

    createTenantConfig(keyValue: KeyValueModel): Observable<TenantConfig> {
        return this.http
            .post<ITenantConfig>(`${this.environment.apiUrl}/tenant-config`, {
                configKey: keyValue.key,
                configValue: keyValue.value,
            })
            .pipe(map((query) => new TenantConfig(query)));
    }

    updateTenantConfig(tenantConfig: TenantConfig): Promise<TenantConfig> {
        return this.http
            .put<ITenantConfig>(`${this.environment.apiUrl}/tenant-config/${tenantConfig.id}`, {
                config_key: tenantConfig.key,
                config_value: { home_screen: tenantConfig.value },
            })
            .pipe(map((query) => new TenantConfig(query)))
            .toPromise();
    }

    getTenantConfig(id: string): Observable<TenantConfig[]> {
        return this.http.get<ITenantConfig[]>(`${this.environment.apiUrl}/tenant-config/${id}`).pipe(map((queries) => queries.map((query) => new TenantConfig(query))));
    }

    deleteTenantConfigs(id: string): Observable<any> {
        return this.http.get<ITenantConfig[]>(`${this.environment.apiUrl}/tenant-config/${id}`);
    }
}
